import { render } from "./logoDesktop.vue?vue&type=template&id=2ad2472e"
import script from "./logoDesktop.vue?vue&type=script&lang=js"
export * from "./logoDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3815826973/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__